import { render, staticRenderFns } from "./EditCategoryPrinciple.vue?vue&type=template&id=256dea68&scoped=true&"
import script from "./EditCategoryPrinciple.vue?vue&type=script&lang=js&"
export * from "./EditCategoryPrinciple.vue?vue&type=script&lang=js&"
import style0 from "./EditCategoryPrinciple.vue?vue&type=style&index=0&id=256dea68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256dea68",
  null
  
)

export default component.exports